import { useContext } from 'react';
import invariant from 'invariant';
import AuthContext from '../AuthProvider/AuthContext';
/**
 * Hook vraci handler pro spusteni autentikacni pipeline.
 *
 * Signatura handleru: `(credentials, directContext) => Promise<{ user, meta }>`
 */

export default function useAuthenticate() {
  var ctx = useContext(AuthContext);
  invariant(ctx, "'useAuthenticate' can be called only inside 'AuthProvider'");
  return ctx.authenticate;
}